<template>
  <MallBottomSheet :dim="'normal'" @close="$emit('confirm')">
    <div class="mall-card-error-sheet">
      <Mall3dIcon :src="cardIcon" :size="80" :screenOpacity="0.4" />
      <div class="mall-card-error-sheet__text">
        <span class="mall-card-error-sheet__title">{{ message }}</span>
        <span class="typo-body-m-medium">
          <span class="mall-card-error-sheet__line">잘못된 카드 정보를 반복 입력할 경우</span>
          <span class="mall-card-error-sheet__line">모든 카드 거래가 중지될 수 있으니</span>
          <span class="mall-card-error-sheet__line">신중히 입력해 주세요.</span>
        </span>
      </div>
    </div>

    <template slot="buttons">
      <MallButton :label="'카드 정보 재입력하기'" :type="'primary'" @click="$emit('confirm')" />
    </template>
  </MallBottomSheet>
</template>

<script>
import Mall3dIcon from '@/components/new/atoms/Mall3dIcon.vue'
import MallButton from '@/components/new/atoms/MallButton.vue'
import MallBottomSheet from '@/components/new/molecules/MallBottomSheet.vue'

// 카드 등록 실패 (카드사·결제 오류 메시지 노출)
export default {
  name: 'MallCardErrorSheet',
  components: {
    Mall3dIcon,
    MallButton,
    MallBottomSheet,
  },
  props: {
    // 서버가 준 오류 메시지
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cardIcon: require('@/assets/mall/img_card_3d.png'),
    }
  },
}
</script>

<style scoped>
.mall-card-error-sheet {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.mall-card-error-sheet__text {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
  text-align: center;
}

.mall-card-error-sheet__title {
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
  word-break: keep-all;
}

.mall-card-error-sheet__line {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallCardErrorSheet.vue